<template>
  <v-dialog
    v-model="show"
    hide-overlay
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Informe Parte Semanal</v-toolbar-title>
          <v-divider></v-divider>
          <v-btn icon @click="buscarFotos">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <h6>Obra: {{ listadopartesemanal.obra }}</h6>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h6>Código: {{ codigo }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <h6>Cliente: {{ listadopartesemanal.cliente }}</h6>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h6>Comitente: {{ listadopartesemanal.comitente }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <h6>Semana: {{ listadopartesemanal.semana }}</h6>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h6>N° de Parte Semanal: {{ codgral }}</h6>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <h6>Responsable: {{ listadopartesemanal.responsable }}</h6>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <h6>Contratistas: {{ listadopartesemanal.contratistas }}</h6>
            </v-col>
          </v-row>
        </v-card-text>
        <v-row justify="center">
          <v-expansion-panels focusable accordion>
            <!-- <v-expansion-panel>
          <v-expansion-panel-header>Planos intervinientes</v-expansion-panel-header>
          <v-expansion-panel-content>
           <v-simple-table dense>
          <template v-slot:default>
          <thead>
          <tr>
          <th class="text-left">
          Planos
          </th>
          </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in listadopartesemanal.planos"
          :key="item.plano"
        >
          <td>{{ item.plano }}</td>
          </tr>
      </tbody>
    </template>
  </v-simple-table>
          </v-expansion-panel-content>
        </v-expansion-panel> -->
            <v-expansion-panel>
              <v-expansion-panel-header
                >Tareas Semana Anterior</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Tarea
                        </th>
                        <th class="text-left">
                          Porcentaje
                        </th>
                        <th class="text-left">
                          Previsto
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in listadopartesemanal.tareasSA"
                        :key="item.tarea"
                      >
                        <td>{{ item.tarea }}</td>
                        <td>{{ item.porcentaje }}</td>
                        <td>{{ item.previsto }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Personal</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nombre
                        </th>
                        <th class="text-left">
                          Legajo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in listadopartesemanal.personal"
                        :key="item.nombre"
                      >
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.legajo }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Equipos</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Equipo
                        </th>
                        <th class="text-left">
                          Lunes
                        </th>
                        <th class="text-left">
                          Martes
                        </th>
                        <th class="text-left">
                          Miercoles
                        </th>
                        <th class="text-left">
                          Jueves
                        </th>
                        <th class="text-left">
                          Viernes
                        </th>
                        <th class="text-left">
                          Sábado
                        </th>
                        <th class="text-left">
                          Domingo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in listadopartesemanal.equipos"
                        :key="item.equipo"
                      >
                        <td>{{ item.equipo }}</td>
                        <td>{{ item.lunes }}</td>
                        <td>{{ item.martes }}</td>
                        <td>{{ item.miercoles }}</td>
                        <td>{{ item.jueves }}</td>
                        <td>{{ item.viernes }}</td>
                        <td>{{ item.sabado }}</td>
                        <td>{{ item.domingo }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Condiciones Climáticas</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-row dense>
                  <v-col cols="12" sm="4" md="4">
                    <h6>Lunes: {{ listadopartesemanal.climalunes }}</h6>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <h6>Martes: {{ listadopartesemanal.climamartes }}</h6>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <h6>Miercóles: {{ listadopartesemanal.climamiercoles }}</h6>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="3" md="3">
                    <h6>Jueves: {{ listadopartesemanal.climajueves }}</h6>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <h6>Viernes: {{ listadopartesemanal.climaviernes }}</h6>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <h6>Sábado: {{ listadopartesemanal.climasabado }}</h6>
                  </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <h6>Domingo: {{ listadopartesemanal.climadomingo }}</h6>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Accidentes</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nombre
                        </th>
                        <th class="text-left">
                          Legajo
                        </th>
                        <th class="text-left">
                          Empresa
                        </th>
                        <th class="text-left">
                          Observaciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in listadopartesemanal.accidentes"
                        :key="item.nombre"
                      >
                        <td>{{ item.nombre }}</td>
                        <td>{{ item.legajo }}</td>
                        <td>{{ item.empresa }}</td>
                        <td>{{ item.observ }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Observaciones</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="multi-line">
                  {{ listadopartesemanal.observ }}
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Tareas Previstas para la semana</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Tarea
                        </th>
                        <th class="text-left">
                          Plano
                        </th>
                        <th class="text-left">
                          Porcentaje
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in listadopartesemanal.tareasP"
                        :key="item.tarea"
                      >
                        <td>{{ item.tarea }}</td>
                        <td>{{ item.plano }}</td>
                        <td>{{ item.porcentaje }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header
                >Galeria de Fotos</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-card>
                  <div class="row" style="margin:10px">
                    <v-carousel height="550">
                      <v-carousel-item
                        v-for="(item, i) in listadopartesemanal.fotos"
                        :key="i"
                        :src="item.path"
                        contain
                        max-height="500px"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                        title="listadopartesemanal.titulo"
                      >
                        <v-row>
                          <div style="margin:20px">
                            <font color="#000000" face="Arial" size="3">{{
                              item.titulo
                            }}</font>
                          </div>
                        </v-row>
                      </v-carousel-item>
                    </v-carousel>
                  </div>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
</style>
<script>
import router from "../../../src/router/index";
import axios from "../../../src/axios-auth";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    listadopartesemanal: [],
  }),
  props: ["visible", "codigo", "codgral"],
  // watch: {
  //   listadofotos: []
  // },
  computed: {
    show: {
      get() {
        this.buscarDatosParteSemanal();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarInforme();
          console.log("cerrado");
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarInforme() {
      this.listadopartesemanal = [];
      this.listadofotos = [];
    },

    buscarFotos() {
      const codigoobra = this.codigo;
      const codigoparte = this.codgral;
      if (codigoparte != null) {
        let self = this;
        axios
          .get("/Obras/CargarFotos?", {
            params: {
              codigo: codigoobra,
              codgral: codigoparte,
            },
          })
          .then((response) => {
            self.listadofotos = response.data;
            self.exportarPDF(self.listadofotos);
          })
          .catch((error) => {
            self.listadofotos = [];
            console.log(error);
          });
      }
    },

    exportarPDF(fotopdf) {
      var vm = this;
      var columnsTP = [
        { title: "Tarea", dataKey: "tarea" },
        { title: "Planos", dataKey: "plano" },
        { title: "Porcentaje", dataKey: "porcentaje" },
      ];
      var columnsPl = [{ title: "Planos Intervinientes", dataKey: "plano" }];
      var columnsSA = [
        { title: "Tarea ", dataKey: "tarea" },
        { title: "Porcentaje", dataKey: "porcentaje" },
        { title: "Porcentaje previsto", dataKey: "previsto" },
      ];
      var columnsP = [
        { title: "Nombre", dataKey: "nombre" },
        { title: "Legajo", dataKey: "legajo" },
      ];
      var columnsE = [
        { title: "Equipo", dataKey: "equipo" },
        { title: "Lunes", dataKey: "lunes" },
        { title: "Martes", dataKey: "martes" },
        { title: "Miércoles", dataKey: "miercoles" },
        { title: "Jueves", dataKey: "jueves" },
        { title: "Viernes", dataKey: "viernes" },
        { title: "Sábado", dataKey: "sabado" },
        { title: "Domingo", dataKey: "domingo" },
      ];
      var columnsA = [
        { title: "Nombre", dataKey: "nombre" },
        { title: "Legajo", dataKey: "legajo" },
        { title: "Empresa", dataKey: "empresa" },
        { title: "Observaciones", dataKey: "observ" },
      ];
      var columnsF = [
        { title: "Titulo", dataKey: "titulo" },
        { title: "Foto", dataKey: "foto" },
      ];
      var doc = new jsPDF();
      doc.setLineWidth(0.5);
      doc.line(10, 11, 200, 11);
      doc.line(10, 11, 10, 41);
      doc.line(40, 26, 200, 26);
      doc.addImage(
        "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",
        "JPEG",
        15,
        15,
        22,
        22
      );
      doc.text("PARTE SEMANAL DE OBRA", 60, 20);
      doc.setFontSize(10);
      doc.text("N°: " + vm.codgral, 180, 20);
      doc.text("EI 114 Rev. ", 173, 35);
      doc.line(40, 11, 40, 41);
      doc.line(165, 11, 165, 41);
      doc.line(10, 41, 200, 41);
      doc.line(200, 11, 200, 41);
      doc.setFontSize(10);
      doc.text(
        "Obra: " + vm.codigo + " - " + vm.listadopartesemanal.obra,
        50,
        30
      );
      doc.text("Cliente: " + vm.listadopartesemanal.cliente, 50, 35);
      doc.text("Comitente: " + vm.listadopartesemanal.comitente, 50, 40);

      doc.setFontSize(11);
      doc.text("Responsable: " + vm.listadopartesemanal.responsable, 15, 50);
      doc.text(
        "Subcontratista/s: " + vm.listadopartesemanal.contratistas,
        15,
        55
      );
      doc.text("Semana: " + vm.listadopartesemanal.semana, 15, 60);

      doc.text("TAREAS COMPLETADAS LA SEMANA ANTERIOR ", 15, 70);

      // doc.autoTable(columnsPl, vm.listadopartesemanal.planos, {
      // margin: {top: 20},
      // });
      doc.autoTable(columnsSA, vm.listadopartesemanal.tareasSA, {
        margin: { top: 75 },
      });

      doc.text(
        "LISTADO DE PERSONAL DE LA SEMANA",
        15,
        doc.autoTable.previous.finalY + 10
      );

      doc.autoTable(columnsP, vm.listadopartesemanal.personal, {
        startY: doc.autoTable.previous.finalY + 20,
        margin: { top: 10 },
      });

      doc.text("ACCIDENTES EN OBRA", 15, doc.autoTable.previous.finalY + 10);

      doc.autoTable(columnsA, vm.listadopartesemanal.accidentes, {
        startY: doc.autoTable.previous.finalY + 20,
        margin: { top: 10 },
      });

      doc.text(
        "LISTADO DE EQUIPOS UTILIZADOS",
        15,
        doc.autoTable.previous.finalY + 10
      );

      doc.autoTable(columnsE, vm.listadopartesemanal.equipos, {
        startY: doc.autoTable.previous.finalY + 20,
        margin: { top: 10 },
      });
      let finalY = doc.lastAutoTable.finalY;

      doc.line(10, finalY + 5, 200, finalY + 5);
      if (finalY >= 200) {
        doc.addPage();
        finalY = 0;
      }
      doc.setFontSize(12);
      doc.text("Condiciones Climáticas", 10, finalY + 10);
      doc.line(10, finalY + 15, 200, finalY + 15);
      doc.setFontSize(11);
      doc.text("Lunes: " + vm.listadopartesemanal.climalunes, 10, finalY + 20);
      doc.text(
        "Martes: " + vm.listadopartesemanal.climamartes,
        10,
        finalY + 25
      );
      doc.text(
        "Miércoles: " + vm.listadopartesemanal.climamiercoles,
        10,
        finalY + 30
      );
      doc.text(
        "Jueves: " + vm.listadopartesemanal.climajueves,
        10,
        finalY + 35
      );
      doc.text(
        "Viernes: " + vm.listadopartesemanal.climaviernes,
        10,
        finalY + 40
      );
      doc.text(
        "Sábado: " + vm.listadopartesemanal.climasabado,
        10,
        finalY + 45
      );
      doc.text(
        "Domingo: " + vm.listadopartesemanal.climadomingo,
        10,
        finalY + 50
      );

      var finalO = finalY + 50;

      if (finalO >= 285) {
        doc.addPage();
        finalO = 0;
      }

      doc.setFontSize(12);
      doc.text("Observaciones", 10, finalO + 10);
      // doc.text(vm.listadopartesemanal.observ, 10, finalO+20);

      var textoSplit = vm.listadopartesemanal.observ.split(/\r|\n\r|\n/);
      finalO = finalO + 20;
      console.log("Frase: " + textoSplit[1]);
      for (var i = 0; i < textoSplit.length; i++) {
        finalO = finalO + 5;
        if (textoSplit[i].length < 75) {
          doc.text(textoSplit[i], 10, finalO);
        } else {
          var lineSplit = textoSplit[i].split(" ");
          var linePrint = "";
          var lineTemp = "";
          for (var j = 0; j < lineSplit.length; j++) {
            if (linePrint.length >= 72) {
              console.log("linea: " + lineSplit[j]);
              if (j == lineSplit.length - 1)
                doc.text(lineSplit[j], 10, finalO + 5);

              lineTemp = linePrint + lineSplit[j];
              if (lineTemp.length < 72) {
                doc.text(lineTemp, 10, finalO);
                linePrint = "";
              } else {
                doc.text(linePrint, 10, finalO);
                linePrint = lineSplit[j] + " ";
              }
              finalO = finalO + 5;

              if (finalO > 285) {
                doc.addPage();
                finalO = 20;
              }
            } else {
              linePrint = linePrint + lineSplit[j] + " ";
              if (j == lineSplit.length - 1) {
                doc.text(linePrint, 10, finalO);
                if (finalO > 285) {
                  doc.addPage();
                  finalO = 20;
                }
              }
            }
          }
        }
      }
      finalO = finalO + 5;
      if (finalO > 285) {
        finalO = 20;
        doc.addPage();
      }
      doc.text("TAREAS PREVISTA PARA LA SEMANA", 15, finalO + 10);
      doc.autoTable(columnsTP, vm.listadopartesemanal.tareasP, {
        startY: finalO + 20,
        margin: { top: 10 },
      });
      doc.line(
        10,
        doc.autoTable.previous.finalY + 10,
        200,
        doc.autoTable.previous.finalY + 10
      );
      doc.setFontSize(11);
      //}
      doc.addPage();
      //doc.text("FOTOS", 10, 10);
      var inicio = 10;
      var ancho = 0;
      var alto = 0;
      var altototal = 0;

      // for (var i=0; i< vm.listadofotos.length ; i++)
      for (var i = 0; i < fotopdf.length; i++) {
        // if ( vm.listadofotos[i].ancho >  vm.listadofotos[i].alto)
        if (fotopdf[i].alto > fotopdf[i].ancho) {
          if (fotopdf[i].alto < 200) {
            ancho = fotopdf[i].ancho / 2;
            alto = fotopdf[i].alto / 2;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 200 && fotopdf[i].alto < 600) {
            ancho = fotopdf[i].ancho / 6;
            alto = fotopdf[i].alto / 6;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 600 && fotopdf[i].alto < 1000) {
            ancho = fotopdf[i].ancho / 10;
            alto = fotopdf[i].alto / 10;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 1000 && fotopdf[i].alto < 1500) {
            ancho = fotopdf[i].ancho / 16;
            alto = fotopdf[i].alto / 16;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 1500 && fotopdf[i].alto < 2000) {
            ancho = fotopdf[i].ancho / 20;
            alto = fotopdf[i].alto / 20;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 2000 && fotopdf[i].alto < 2600) {
            ancho = fotopdf[i].ancho / 30;
            alto = fotopdf[i].alto / 30;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 2600 && fotopdf[i].alto < 4000) {
            ancho = fotopdf[i].ancho / 40;
            alto = fotopdf[i].alto / 40;
            altototal = altototal + alto;
          }
          if (fotopdf[i].alto >= 4000) {
            ancho = fotopdf[i].ancho / 60;
            alto = fotopdf[i].alto / 60;
            altototal = altototal + alto;
          }
          console.log("alto 1: " + altototal);
        } else {
          if (fotopdf[i].ancho < 200) {
            ancho = fotopdf[i].ancho / 2;
            alto = fotopdf[i].alto / 2;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 200 && fotopdf[i].alto < 600) {
            ancho = fotopdf[i].ancho / 6;
            alto = fotopdf[i].alto / 6;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 600 && fotopdf[i].alto < 1000) {
            ancho = fotopdf[i].ancho / 10;
            alto = fotopdf[i].alto / 10;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 1000 && fotopdf[i].alto < 1500) {
            ancho = fotopdf[i].ancho / 16;
            alto = fotopdf[i].alto / 16;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 1500 && fotopdf[i].alto < 2000) {
            ancho = fotopdf[i].ancho / 20;
            alto = fotopdf[i].alto / 20;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 2000 && fotopdf[i].alto < 2600) {
            ancho = fotopdf[i].ancho / 30;
            alto = fotopdf[i].alto / 30;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 2600 && fotopdf[i].alto < 4000) {
            ancho = fotopdf[i].ancho / 40;
            alto = fotopdf[i].alto / 40;
            altototal = altototal + alto;
          }
          if (fotopdf[i].ancho >= 4000) {
            ancho = fotopdf[i].ancho / 60;
            alto = fotopdf[i].alto / 60;
            altototal = altototal + alto;
          }
          console.log("alto 2: " + altototal);
        }

        // doc.text(vm.listadofotos[i].titulo, 10, inicio );
        doc.text(fotopdf[i].titulo, 10, inicio);
        //doc.addImage(vm.listadopartesemanal.fotos[i].base64Image, 'JPEG',40, inicio, (vm.listadopartesemanal.fotos[i].base64Image.width/10), (vm.listadopartesemanal.fotos[i].base64Image.height/10));
        // doc.addImage(vm.listadofotos[i].base64Image, 'JPEG', (doc.internal.pageSize.getWidth() / 2)-(ancho/2), inicio+5, ancho, alto);
        doc.addImage(
          fotopdf[i].base64Image,
          "JPEG",
          doc.internal.pageSize.getWidth() / 2 - ancho / 2,
          inicio + 5,
          ancho,
          alto
        );
        // if (altototal > 200) {
        //   doc.addPage();
        //   //altototal = alto;
        //   altototal = 0;
        //   inicio = 20;
        // }
        if (i > 0 && i % 2 != 0) {
          doc.addPage();
          //altototal = alto;
          altototal = 0;
          inicio = 20;
          alto = 0;
        }
        inicio = inicio + alto + 10;
      }

      const pageCount = doc.internal.getNumberOfPages();

      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.text(
          "Página " + String(i) + " de " + String(pageCount),
          210 - 20,
          297 - 10,
          null,
          null,
          "right"
        );
      }
      doc.save("ParteSemanal" + vm.codigo + vm.codgral + ".pdf");
    },

    buscarDatosParteSemanal() {
      this.vaciarInforme();
      const codigoobra = this.codigo;
      const codigoparte = this.codgral;
      if (codigoparte != null) {
        let self = this;
        axios
          .get("/Obras/CargarInforme?", {
            params: {
              codigo: codigoobra,
              codgral: codigoparte,
            },
          })
          .then((response) => {
            self.listadopartesemanal = response.data;
          })
          .catch((error) => {
            self.listadopartesemanal = [];
            console.log(error);
          });
      }
    },
  },
};
</script>
